import { useLocation } from '@reach/router';
import { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import LanguageSwitcher from '@/components/common/LanguageSwitcher';
import { INSURANCE } from '@/constants';
import { AgentTypeName } from '@/enums';
import { withPrefix } from '@/helpers/WithPrefix';
import { useAppSelector } from '@/hook';
import { useGoogleAnalytic } from '@/hooks/useGoogleAnalytic';
import { usePageRedirection } from '@/hooks/usePageRedirection';
import { getRoute } from '@/hooks/useRouteSection';
import EGIBlogo from '@/images/Etiqa-EGIB.png';
import EGTBlogo from '@/images/Etiqa-EGTB.png';
import MBBlogo from '@/images/MBB-logo.png';
import { devices } from '@/theme/device';

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const googleAnalytic = useGoogleAnalytic();
  const affiliateState = useAppSelector((state) => state.affiliate);
  const { productType, entity } = getRoute(location.pathname);
  const { getHomepageUrl } = usePageRedirection();

  useEffect(() => {
    const metaViewport = document.createElement('meta');
    metaViewport.name = 'viewport';
    metaViewport.content =
      'width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1';
    document.head.appendChild(metaViewport);

    return () => {
      // Cleanup if needed
      document.head.removeChild(metaViewport);
    };
  }, []);

  const handleLogoClickEvent = () => {
    googleAnalytic.goToHome();
  };

  const trackLanguageChange = (newLanguage: string) => {
    googleAnalytic.selectLanguage(newLanguage);
  };

  const AffiliateSection = () => {
    return affiliateState.type === AgentTypeName.Banca ? (
      <AffiliateInfo>
        <span>Branch Code : {affiliateState.bancaBranchCode}</span>
        <br />
        <span>PF Number : {affiliateState.salesPfNumber}</span>
      </AffiliateInfo>
    ) : (
      <AffiliateInfo>
        <span>Agent Code : {affiliateState.agentCode}</span>
        <br />
        <span>Agent Branch Code: {affiliateState.agentBranchCode}</span>
      </AffiliateInfo>
    );
  };

  useEffect(() => {
    const metaViewport = document.createElement('meta');
    metaViewport.name = 'viewport';
    metaViewport.content =
      'width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1';
    document.head.appendChild(metaViewport);

    return () => {
      // Cleanup if needed
      document.head.removeChild(metaViewport);
    };
  }, []);

  useEffect(() => {
    const metaViewport = document.createElement('meta');
    metaViewport.name = 'viewport';
    metaViewport.content =
      'width=device-width, initial-scale=1, shrink-to-fit=no, maximum-scale=1';
    document.head.appendChild(metaViewport);

    return () => {
      // Cleanup if needed
      document.head.removeChild(metaViewport);
    };
  }, []);

  if (affiliateState.loading) {
    return null; // or a loading spinner
  }

  return (
    <StylesNavbar isBanca={affiliateState.type === AgentTypeName.Banca}>
      <Container>
        <StylesLogo>
          <Navbar.Brand href={getHomepageUrl()} onClick={handleLogoClickEvent}>
            <Logo
              src={withPrefix(
                !(affiliateState.type === AgentTypeName.Banca)
                  ? entity === INSURANCE
                    ? EGIBlogo
                    : EGTBlogo
                  : MBBlogo,
              )}
              alt="Logo"
            />
          </Navbar.Brand>
        </StylesLogo>
        <Navbar.Toggle />
        <StylesTitle>{t(productType + `.header.` + entity)}</StylesTitle>
        <Styleslanguage>
          <Navbar.Collapse className="justify-content-end">
            {affiliateState.isValid ? <AffiliateSection /> : <></>}
            <LanguageSwitcher onLocaleChange={trackLanguageChange} />
          </Navbar.Collapse>
        </Styleslanguage>
      </Container>
    </StylesNavbar>
  );
};

export default Header;

const StylesNavbar = styled(Navbar)<{ isBanca?: boolean }>`
  background-color: ${(props) =>
    props.isBanca ? 'rgb(252, 196, 12); !important' : '#f8f9fa'};
`;

const StylesLogo = styled.div`
  @media only screen and ${devices.xs} {
    flex: 0;
  }
  @media only screen and ${devices.lg} {
    flex: 1;
  }
`;

const StylesTitle = styled(Navbar.Text)`
  flex: 1;
  text-align: center;
  font-weight: 700 !important;
  color: #000 !important;
  font-size: ${(props: any) => props.theme.smallScreenBodyText2};

  @media only screen and ${devices.xs} {
    display: none;
  }
  @media only screen and ${devices.lg} {
    display: block;
  }
`;

const Styleslanguage = styled.div`
  flex: 1;
  font-size: ${(props: any) => props.theme.smallScreenDetails};
`;

const AffiliateInfo = styled.div`
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  font-size: ${(props: any) => props.theme.smallScreenDetails};
`;

const Logo = styled.img`
  margin-right: 5%;

  @media only screen and ${devices.xs} {
    height: 40px;
  }
  @media only screen and ${devices.lg} {
    height: 45px;
  }
`;
